import { createSlice } from "@reduxjs/toolkit";



export const redirectSlice = createSlice({
    name: "redirect",
    initialState: {
        redirectTo: ""
    },
    reducers: {
        setRedirectTo: (state, action) => {
            state.redirectTo = action.payload;
        },
        clearRedirectTo: (state) => {
            state.redirectTo = "";
        }
    }
})

export const { setRedirectTo, clearRedirectTo } = redirectSlice.actions;

export const selectRedirectTo = (state: any) => state.redirect.redirectTo;

export default redirectSlice.reducer;